import { render, staticRenderFns } from "./NodeInput.vue?vue&type=template&id=510f550b&scoped=true"
import script from "./NodeInput.vue?vue&type=script&lang=js"
export * from "./NodeInput.vue?vue&type=script&lang=js"
import style0 from "./NodeInput.vue?vue&type=style&index=0&id=510f550b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f550b",
  null
  
)

export default component.exports